'use client';

import './donate-form.scss';

import React from 'react';

import { Form } from '@sola/ark-core/molecules/form/form.js';

import { DonateAmountSelector } from './components/donate-amount-selector';
import { DonateFrequencySelector } from './components/donate-frequency-selector';
import { DonateSubmitButton } from './components/donate-submit-button';
import { useDonate } from './donate-context';
import { DonateFrequency } from './donate.types';
import { useDonateActions } from './hooks/use-donate-actions';

export interface DonateFormProps {
  focusOnLoad?: boolean;
  alt?: boolean;
}
export const DonateForm: React.FC<DonateFormProps> = ({
  focusOnLoad = false,
  alt,
}) => {
  const { variant, state } = useDonate();
  const { handleSubmit } = useDonateActions();

  return (
    <Form
      onSubmit={handleSubmit}
      options={{
        defaultValues: {
          donateFrequency: state.donateFrequency,
          [`${DonateFrequency.OneTime}-donateAmount`]:
            state.selectedAmounts[DonateFrequency.OneTime],
          [`${DonateFrequency.Monthly}-donateAmount`]:
            state.selectedAmounts[DonateFrequency.Monthly],
          [`${DonateFrequency.Annually}-donateAmount`]:
            state.selectedAmounts[DonateFrequency.Annually],
        },
      }}
      className={`Donate Donate--${variant} flex flex-col ${
        variant === 'grid' ? 'gap-comfy-md' : 'gap-comfy-lg'
      }`}
    >
      {alt && (
        <>
          <div className="flex flex-row gap-comfy-sm">
            <DonateFrequencySelector alt={alt} />
            <DonateAmountSelector alt={alt} focusOnLoad={focusOnLoad} />
          </div>
          <DonateSubmitButton alt={alt} />
        </>
      )}
      {!alt && (
        <>
          <DonateFrequencySelector />
          <DonateAmountSelector focusOnLoad={focusOnLoad} />
          <DonateSubmitButton />
        </>
      )}
    </Form>
  );
};
